window.addEventListener("DOMContentLoaded", () => {
  const t = document.getElementById("liquidCartIcon");
  try {
    if (t) {
      t.addEventListener("click", () => window.toggleLiquidCart());
    }
    let s = ({ cart }) => {
      const i = document.getElementById("cartItemCount");
      if (i) {
        i.innerText =
          cart.itemCount == 0
            ? ""
            : cart.itemCount > 99
            ? "99+"
            : cart.itemCount;
      }
    };
    window.Elements().pubSub.subscribe("LiquidCartLoaded", s);
    window.Elements().pubSub.subscribe("LiquidCartUpdated", s);
  } catch (err) {
    alert(err);
  }
});
